import React, {useEffect, useState} from "react";
import {FaUpload} from "@react-icons/all-files/fa/FaUpload";

function UserFileUpload(props) {
    const [image, setImage] = useState({
        preview: props.defaultUrl,
        data: "",
    });

    useEffect(() => {
        setImage(({
            preview: props.fileId ? `${process.env.REACT_APP_HOST_BASE_URL}${props.url}/${props.fileId}` : props.defaultUrl,
            data: "",
        }))
    }, [props.fileId, props.url, props.defaultUrl])

    const handleFileChange = (e) => {
        setImage({
            preview: URL.createObjectURL(e.target.files[0]),
            data: e.target.files[0],
        });
        props.getFileImage(e.target.files[0])
    };

    return (
        <div className="w-[100%] h-full ">
            <div className=" w-full flex flex-row h-full flex items-center">
                <img width={100} height={100} className="rounded-[8px]" src={image.preview} alt="User logo"/>
                <div className="ml-8 mt-10 flex flex-col items-center">
                    <label
                        className="inline-flex items-center text-sm bg-[#1F2937] p-2 rounded-[4px] cursor-pointer text-white "
                        htmlFor="fileImage">
                        <FaUpload className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true"/>
                        File upload
                    </label>
                    <input className="hidden" type="file" id="fileImage" onChange={handleFileChange}/>
                </div>

            </div>
        </div>

    );
}

export default UserFileUpload;
